export default __webpack_public_path__ + "static/media/gallery_00.044c9211.jpg";